// src/components/HasPermission.jsx
import React from 'react';

export default function HasPermission({ children, allowedRoles }) {
  // Local storage se current user ka role nikaalo
  const currentRole = localStorage.getItem("adminRole");

  // Agar user logged in nahi hai (role null hai), toh button mat dikhao
  if (!currentRole) return null;

  // MASTER LOGIC (Admin Bypass)
  // Agar role 'admin' hai, YA role allowedRoles array me hai -> Element dikhao
  if (currentRole === 'admin' || allowedRoles.includes(currentRole)) {
    return <>{children}</>;
  }

  // Warna button UI se bilkul gayab kar do
  return null;
}